export class Cid {
    id:number | undefined;
    name:string | undefined;    
    code:string | undefined;
    gender:string | undefined;
}
